import React from 'react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { TextField, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import { StylesProvider, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { ButtonStyles } from './ButtonStyles'

const ContactFormEndpoint = `https://api.hsforms.com/submissions/v3/integration/submit/7898466/da4b49b8-9769-46f5-80f1-caa044dccbe7`

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Twentieth Century', 'sans-serif'].join(','),
    fontSize: 12,
  },
})

interface FormFields {
  [key: string]: string
}

const SubscribeForm = () => {
  const { register, handleSubmit, errors } = useForm()

  const onSubmit = async (data: any) => {
    try {
      // Construct the HS fields for submission
      const payload = Object.keys(data).map((key: string) => {
        return { name: key, value: data[key] }
      })

      console.log(JSON.stringify({ fields: payload }))

      const result = await axios.post(ContactFormEndpoint, JSON.stringify({ fields: payload }), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } catch (err) {
      toast.error('Error submitting form - Please call us on 02 9233 8633')
      return
    }
    toast.success(`Thanks for signing up!`)
  }

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <InputGroup>
            <Input
              variant="outlined"
              label="Email"
              fullWidth
              inputRef={register({ required: true })}
              name="email"
              type="email"
              error={!!errors.email}
              helperText={errors.email && 'Looks like you forgot your email'}
            />
          </InputGroup>

          <SubmitButton type="submit"></SubmitButton>
        </Form>
      </ThemeProvider>
    </StylesProvider>
  )
}

export { SubscribeForm }

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 100%;
`
// Varies from the inputGroup in the enquiry form only in that it's not animated
const InputGroup = styled.div`
  border-radius: 5px;
  justify-content: space-between;
  color: white;
  flex: 4;
  margin: 0 1.5rem;

  @media (max-width: 768px) {
    width: 94%;
  }
`

const Input = styled(TextField)`
  & .MuiFormLabel-root {
    font-family: Slate, sans-serif;
    font-weight: 100;
  }
`

const SubmitButton = styled.input`
  ${ButtonStyles}
  flex: 1;
`
